/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const create_user = /* GraphQL */ `
  mutation Create_user($input: userInputs) {
    create_user(input: $input)
  }
`;
export const edit_user = /* GraphQL */ `
  mutation Edit_user($input: userInputs) {
    edit_user(input: $input)
  }
`;
export const resend_owner_invite = /* GraphQL */ `
  mutation Resend_owner_invite($input: userInputs) {
    resend_owner_invite(input: $input)
  }
`;
export const create_organization = /* GraphQL */ `
  mutation Create_organization($input: organizationInputs) {
    create_organization(input: $input)
  }
`;
export const edit_organization = /* GraphQL */ `
  mutation Edit_organization($input: organizationInputs) {
    edit_organization(input: $input)
  }
`;
export const reset_organization_api_usage = /* GraphQL */ `
  mutation Reset_organization_api_usage(
    $input: resetOrganizationApiUsageInput
  ) {
    reset_organization_api_usage(input: $input)
  }
`;
export const set_bms_global_settings = /* GraphQL */ `
  mutation Set_bms_global_settings($input: bmsGlobalSettingsInput) {
    set_bms_global_settings(input: $input)
  }
`;
export const create_category = /* GraphQL */ `
  mutation Create_category($input: categoryInputs) {
    create_category(input: $input)
  }
`;
export const edit_category = /* GraphQL */ `
  mutation Edit_category($input: categoryInputs) {
    edit_category(input: $input)
  }
`;
export const create_template = /* GraphQL */ `
  mutation Create_template($input: templateInputs) {
    create_template(input: $input)
  }
`;
export const edit_template = /* GraphQL */ `
  mutation Edit_template($input: templateInputs) {
    edit_template(input: $input)
  }
`;
export const create_master_medications = /* GraphQL */ `
  mutation Create_master_medications($input: medicationInputs) {
    create_master_medications(input: $input)
  }
`;
export const edit_master_medications = /* GraphQL */ `
  mutation Edit_master_medications($input: medicationInputs) {
    edit_master_medications(input: $input)
  }
`;
export const create_master_medication_class = /* GraphQL */ `
  mutation Create_master_medication_class($input: medicationClassInputs) {
    create_master_medication_class(input: $input)
  }
`;
export const edit_master_medication_class = /* GraphQL */ `
  mutation Edit_master_medication_class($input: medicationClassInputs) {
    edit_master_medication_class(input: $input)
  }
`;
export const create_announcement = /* GraphQL */ `
  mutation Create_announcement($input: announcementInputs) {
    create_announcement(input: $input)
  }
`;
export const edit_announcement = /* GraphQL */ `
  mutation Edit_announcement($input: announcementInputs) {
    edit_announcement(input: $input)
  }
`;
export const create_master_checklists = /* GraphQL */ `
  mutation Create_master_checklists($input: MasterChecklistInput) {
    create_master_checklists(input: $input)
  }
`;
export const edit_master_checklists = /* GraphQL */ `
  mutation Edit_master_checklists($input: MasterChecklistInput) {
    edit_master_checklists(input: $input)
  }
`;
export const manage_organization_license = /* GraphQL */ `
  mutation Manage_organization_license($input: manageOrganizationLicenseInput) {
    manage_organization_license(input: $input)
  }
`;
export const initiate_license_renewal = /* GraphQL */ `
  mutation Initiate_license_renewal($input: intiateLicenseRenewalInput) {
    initiate_license_renewal(input: $input)
  }
`;
export const change_user_license_type = /* GraphQL */ `
  mutation Change_user_license_type($input: changeUserLicenseTypeInput) {
    change_user_license_type(input: $input)
  }
`;
export const transfer_organization_ownership = /* GraphQL */ `
  mutation Transfer_organization_ownership(
    $input: transferOrganizationOwnershipInput
  ) {
    transfer_organization_ownership(input: $input)
  }
`;
export const create_testimonial = /* GraphQL */ `
  mutation Create_testimonial($input: testimonialInputs) {
    create_testimonial(input: $input)
  }
`;
export const edit_testimonial = /* GraphQL */ `
  mutation Edit_testimonial($input: testimonialInputs) {
    edit_testimonial(input: $input)
  }
`;
export const create_blog = /* GraphQL */ `
  mutation Create_blog($input: blogInputs) {
    create_blog(input: $input)
  }
`;
export const edit_blog = /* GraphQL */ `
  mutation Edit_blog($input: blogInputs) {
    edit_blog(input: $input)
  }
`;
export const create_user_guide_topic = /* GraphQL */ `
  mutation Create_user_guide_topic($input: userGuideTopicInputs) {
    create_user_guide_topic(input: $input)
  }
`;
export const edit_user_guide_topic = /* GraphQL */ `
  mutation Edit_user_guide_topic($input: userGuideTopicInputs) {
    edit_user_guide_topic(input: $input)
  }
`;
export const upload_knowledge_base_file = /* GraphQL */ `
  mutation Upload_knowledge_base_file($input: kbFileInputs) {
    upload_knowledge_base_file(input: $input)
  }
`;
export const edit_knowledge_base_file = /* GraphQL */ `
  mutation Edit_knowledge_base_file($input: kbFileInputs) {
    edit_knowledge_base_file(input: $input)
  }
`;
export const start_knowledge_base_ingestion = /* GraphQL */ `
  mutation Start_knowledge_base_ingestion($input: injestionStatusInput) {
    start_knowledge_base_ingestion(input: $input)
  }
`;
export const create_master_medication_category = /* GraphQL */ `
  mutation Create_master_medication_category(
    $input: medicationCategoryMastersInputs
  ) {
    create_master_medication_category(input: $input)
  }
`;
export const edit_master_medication_category = /* GraphQL */ `
  mutation Edit_master_medication_category(
    $input: medicationCategoryMastersInputs
  ) {
    edit_master_medication_category(input: $input)
  }
`;
export const create_lab_masters = /* GraphQL */ `
  mutation Create_lab_masters($input: labMastersInputs) {
    create_lab_masters(input: $input)
  }
`;
export const edit_lab_masters = /* GraphQL */ `
  mutation Edit_lab_masters($input: labMastersInputs) {
    edit_lab_masters(input: $input)
  }
`;
export const edit_ticket = /* GraphQL */ `
  mutation Edit_ticket($input: ticketInputs) {
    edit_ticket(input: $input)
  }
`;
export const add_correspondence = /* GraphQL */ `
  mutation Add_correspondence($input: ticketInputs) {
    add_correspondence(input: $input)
  }
`;
export const edit_correspondence = /* GraphQL */ `
  mutation Edit_correspondence($input: ticketInputs) {
    edit_correspondence(input: $input)
  }
`;
export const create_support_module_masters = /* GraphQL */ `
  mutation Create_support_module_masters($input: supportModuleMasterInputs) {
    create_support_module_masters(input: $input)
  }
`;
export const edit_support_module_masters = /* GraphQL */ `
  mutation Edit_support_module_masters($input: supportModuleMasterInputs) {
    edit_support_module_masters(input: $input)
  }
`;
export const create_support_agent = /* GraphQL */ `
  mutation Create_support_agent($input: supportAgentInputs) {
    create_support_agent(input: $input)
  }
`;
export const edit_support_agent = /* GraphQL */ `
  mutation Edit_support_agent($input: supportAgentInputs) {
    edit_support_agent(input: $input)
  }
`;
export const set_auto_close_days = /* GraphQL */ `
  mutation Set_auto_close_days($input: autoCloseDaysSettingsInputs) {
    set_auto_close_days(input: $input)
  }
`;
export const approve_knowledge = /* GraphQL */ `
  mutation Approve_knowledge($input: knowledgeReviewInputs) {
    approve_knowledge(input: $input)
  }
`;
export const bulk_approve_knowledge = /* GraphQL */ `
  mutation Bulk_approve_knowledge($input: knowledgeReviewInputs) {
    bulk_approve_knowledge(input: $input)
  }
`;
export const reject_knowledge = /* GraphQL */ `
  mutation Reject_knowledge($input: knowledgeReviewInputs) {
    reject_knowledge(input: $input)
  }
`;
export const get_knowledge_upload_url = /* GraphQL */ `
  mutation Get_knowledge_upload_url($input: getKnowledgeUploadUrlInput) {
    get_knowledge_upload_url(input: $input)
  }
`;
export const set_portal_maintenance = /* GraphQL */ `
  mutation Set_portal_maintenance($input: setPortalMaintenanceInput) {
    set_portal_maintenance(input: $input)
  }
`;
export const get_upload_url = /* GraphQL */ `
  mutation Get_upload_url($input: getUploadUrlInput) {
    get_upload_url(input: $input)
  }
`;
export const set_portal_release_notes = /* GraphQL */ `
  mutation Set_portal_release_notes($input: setPortalReleaseNotesInput) {
    set_portal_release_notes(input: $input)
  }
`;
